module.exports = __webpack_public_path__ + "static/media/8-8.12811244.mp3";